import { useEffect, useState } from "react";
import moment from "moment";
import { Save } from "lucide-react";
import { Button, Grid } from "@mui/material";
import Modal from "../../../components/Modal/Modal";
import InputLabel from "../../../components/Inputs/InputLabel";
import SimpleBackdrop from "../../../components/Loading/Simplebackdrop";
import { AlertInfo } from "../../../components/Alerts/Alert";
import { api } from "../../../services/api";
import { LicenceType } from "../../../types/LicenceType";

type ModalEditLicenceProps = {
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
    licence: Partial<LicenceType> | null
    setLicence: React.Dispatch<React.SetStateAction<Partial<LicenceType> | null>>
}

export default function ModalEditLicence({ open, setOpen, licence, setLicence }: ModalEditLicenceProps) {
    const [load, setLoad] = useState(false);
    const [inicio_licence, setInicioLicence] = useState("");
    const [final_licence, setFinalLicence] = useState("");
    const [nome_plano_licence, setNomePlanoLicence] = useState("");

    async function handleSave() {
        if (licence && licence.id_licence) {
            setLoad(true);
            try {
                let licence_status = 'expired';
                if(moment(final_licence).isAfter(moment(inicio_licence))) licence_status = 'active';
                const { id_licence, id_escritorio_licence } = licence;
                const dataDb = { id_licence, inicio_licence, final_licence, nome_plano_licence, licence_status, id_escritorio_licence };
                const response = await api.post(`/createnewlicence`, dataDb);
                if (response.data.success) {
                    AlertInfo({ icon: 'success', title: 'Dados Gravados' });
                    setLicence({...licence, ...dataDb, id_licence: response.data.id_licence});
                    setOpen(false);
                } else if (response.data.error) {
                    AlertInfo({ icon: 'error', title: 'Falha na conexão' });
                }
            } catch (error) {
                console.log(error);
                AlertInfo({ icon: 'error', title: 'Falha na conexão' });
            }
            setLoad(false);
        }
    }

    useEffect(() => {
        if (licence) {
            setInicioLicence(moment(licence.inicio_licence).format("YYYY-MM-DD"));
            setFinalLicence(moment(licence.final_licence).format("YYYY-MM-DD"));
            setNomePlanoLicence(licence.nome_plano_licence || "");
        }
    }, [licence]);

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            title="EDITAR LICENÇA"
            maxWidth="sm"
            zIndex={5555}
        >
            <SimpleBackdrop open={load} zIndex={9999} />
            <Grid container spacing={1}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <InputLabel
                        type="date"
                        label="DATA INICIO"
                        value={inicio_licence}
                        setState={setInicioLicence}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <InputLabel
                        type="date"
                        label="DATA FIM"
                        value={final_licence}
                        setState={setFinalLicence}
                    />
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <InputLabel
                        label="DESCRIÇÃO"
                        value={nome_plano_licence}
                        setState={setNomePlanoLicence}
                    />
                </Grid>
                <Grid size={{ xs: false, sm: 4 }} />
                <Grid size={{ xs: 12, sm: 4 }}>
                    <Button
                        variant="contained"
                        size="large"
                        startIcon={<Save />}
                        color='success'
                        fullWidth
                        onClick={handleSave}
                    >
                        Salvar
                    </Button>
                </Grid>
                <Grid size={{ xs: false, sm: 4 }} />
            </Grid>
        </Modal>
    );
}